import { useState } from "react";

import { Form, Input, Button, Checkbox } from "antd";

import { useNavigate } from "react-router-dom";

import OAuthBox from "./OAuthBox";

import { withNamespaces } from "react-i18next";

const { Item } = Form;

const LoginForm = ({ t, setFormType }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const { email, password } = formData;

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = (data) => {
    console.log(data);
    localStorage.setItem("user", JSON.stringify(data));
    navigate("/");
  };

  return (
    <>
      <Form
        name="normal_login"
        className="login-form"
        initialValues={{ remember: true }}
        onFinish={onSubmit}
        style={{ width: "70%" }}
      >
        <Item
          name="email"
          rules={[
            {
              required: true,
              message: "Please input your Email!",
            },
          ]}
        >
          <Input
            placeholder="Email"
            value={email}
            onChange={onChange}
            name="email"
            size="large"
          />
        </Item>
        <Item
          name="password"
          rules={[
            {
              required: true,
              message: "Please input your Password!",
            },
          ]}
        >
          <Input.Password
            placeholder="Password"
            value={password}
            onChange={onChange}
            name="password"
            size="large"
          />
        </Item>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>{t("pages.auth.rememberMe")}</Checkbox>
          </Form.Item>
          <Button
            type="link"
            onClick={() => {
              navigate("/auth/forgot-passowrd");
              setFormType("forgot-passowrd");
            }}
          >
            {t("pages.auth.forgotPassword")}
          </Button>
        </div>

        <Button
          type="primary"
          htmlType="submit"
          style={{
            width: "100%",
            fontWeight: "700",
            fontSize: "16px",
            backgroundColor: "#012F6B",
            borderRadius: "5px",
            border: "none",
          }}
          size="large"
        >
          {t("pages.auth.loginNow")}
        </Button>
        <OAuthBox />
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span>{t("pages.auth.dontHaveAccount")}</span>
          <Button
            type="link"
            onClick={() => {
              navigate("/auth/register");
              setFormType("register");
            }}
          >
            {t("pages.auth.createNewAccount")}
          </Button>
        </div>
      </Form>
    </>
  );
};

export default withNamespaces()(LoginForm);
